import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const Fpipe = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [fpipeUrl, setFpipeUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [addFlange, setAddFlange] = useState(false);

  const [inputs, setInputs] = useState({
    outer_diameter: "",
    wall_thickness: "",
    length: "",
    flange_diameter: "",
    flange_thickness: "",
    bolt_hole_diameter: "",
    bolt_circle_diameter: "",
    bolt_count: "",
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject <model-viewer> script once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/fpipedesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          outer_diameter: parseInt(inputs.outer_diameter),
          wall_thickness: parseFloat(inputs.wall_thickness),
          length: parseFloat(inputs.length),
          add_flange: addFlange,
          flange_diameter: parseInt(inputs.flange_diameter),
          flange_thickness: parseFloat(inputs.flange_thickness),
          bolt_hole_diameter: parseFloat(inputs.bolt_hole_diameter),
          bolt_circle_diameter: parseFloat(inputs.bolt_circle_diameter),
          bolt_count: parseInt(inputs.bolt_count),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setFpipeUrl(data.fpipeurl || "");
        alert("Flange Pipe design is completed!!");
      } else {
        console.error("Error sending flange pipe data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP to GLB and show
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/FpipeToGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting Fpipe STEP to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Pipe with Flanges Design</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      <form
        onSubmit={handleSubmit}
        className="space-y-4 max-w-md mx-auto p-4 border rounded-lg shadow"
      >
        <input
          type="number"
          name="outer_diameter"
          value={inputs.outer_diameter}
          onChange={handleChange}
          placeholder="Outer Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br />
        <br />

        <input
          type="number"
          name="wall_thickness"
          value={inputs.wall_thickness}
          onChange={handleChange}
          placeholder="Wall Thickness"
          className="w-full p-2 border rounded"
          required
        />
        <br />
        <br />

        <input
          type="number"
          name="length"
          value={inputs.length}
          onChange={handleChange}
          placeholder="Length"
          className="w-full p-2 border rounded"
          required
        />
        <br />
        <br />

        <select
          value={addFlange ? "yes" : "no"}
          onChange={(e) => setAddFlange(e.target.value === "yes")}
          className="w-full p-2 border rounded"
        >
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
        <br />
        <br />

        {addFlange && (
          <div className="space-y-3 border-t pt-4">
            <h3 className="text-lg font-medium">Flange Details</h3>

            <input
              type="number"
              name="flange_diameter"
              value={inputs.flange_diameter}
              onChange={handleChange}
              placeholder="Flange Diameter"
              className="w-full p-2 border rounded"
              required
            />
            <br />
            <br />

            <input
              type="number"
              name="flange_thickness"
              value={inputs.flange_thickness}
              onChange={handleChange}
              placeholder="Flange Thickness"
              className="w-full p-2 border rounded"
              required
            />
            <br />
            <br />

            <input
              type="number"
              name="bolt_hole_diameter"
              value={inputs.bolt_hole_diameter}
              onChange={handleChange}
              placeholder="Bolt Hole Diameter"
              className="w-full p-2 border rounded"
              required
            />
            <br />
            <br />

            <input
              type="number"
              name="bolt_circle_diameter"
              value={inputs.bolt_circle_diameter}
              onChange={handleChange}
              placeholder="Bolt Circle Diameter"
              className="w-full p-2 border rounded"
              required
            />
            <br />
            <br />

            <input
              type="number"
              name="bolt_count"
              value={inputs.bolt_count}
              onChange={handleChange}
              placeholder="Bolt Count"
              className="w-full p-2 border rounded"
              required
            />
          </div>
        )}

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Submit
        </button>
      </form>

      <br />
      <p>Fpipe STEP File: {fpipeUrl}</p>

      {fpipeUrl && (
        <>
          <a href={fpipeUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
          <br />
          <br />
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Flange Pipe Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Flange Pipe model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{ width: "600px", height: "400px", backgroundColor: "grey" }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Fpipe;
